"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import styles from "./DelegationHTML.module.scss";
import { Container, Row, Col } from "react-bootstrap";
import Image from "next/image";
interface Props {
  path?: string;
  title?: string;
}
export default function DelegationHTML(props) {
  const $ = _c(18);
  const [html, setHtml] = useState("");
  const [error, setError] = useState(false);
  let titleLighter = "";
  let titleDarker = props.title;
  if (props.title?.includes(" ")) {
    let t0;
    if ($[0] !== props.title) {
      t0 = props.title.split(" ");
      $[0] = props.title;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    let firstWord;
    let rest;
    if ($[2] !== t0) {
      [firstWord, ...rest] = t0;
      $[2] = t0;
      $[3] = firstWord;
      $[4] = rest;
    } else {
      firstWord = $[3];
      rest = $[4];
    }
    titleLighter = firstWord;
    titleDarker = rest.join(" ");
  }
  let t0;
  let t1;
  if ($[5] !== props.path) {
    t0 = () => {
      if (props.path) {
        const url = `https://6529bucket.s3.eu-west-1.amazonaws.com/seize_html/delegations-center-getting-started/html/${props.path}.html`;
        fetch(url).then(response => {
          if (response.status === 200) {
            response.text().then(htmlText => {
              setHtml(htmlText);
              setError(false);
            });
          } else {
            setError(true);
          }
        });
      } else {
        setError(true);
      }
    };
    t1 = [props.path];
    $[5] = props.path;
    $[6] = t0;
    $[7] = t1;
  } else {
    t0 = $[6];
    t1 = $[7];
  }
  useEffect(t0, t1);
  if (error) {
    let t2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className={`${styles.mainContainer} ${styles.pageNotFound}`}><Image unoptimized={true} width="0" height="0" style={{
          height: "auto",
          width: "100px"
        }} src="/SummerGlasses.svg" alt="SummerGlasses" /><h2>404 | PAGE NOT FOUND</h2></div>;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  } else {
    let t2;
    if ($[9] !== props.title || $[10] !== titleDarker || $[11] !== titleLighter) {
      t2 = props.title && <Row><Col><h1>{titleLighter && `${titleLighter} `}{titleDarker}</h1></Col></Row>;
      $[9] = props.title;
      $[10] = titleDarker;
      $[11] = titleLighter;
      $[12] = t2;
    } else {
      t2 = $[12];
    }
    let t3;
    if ($[13] !== html) {
      t3 = <Row className="pt-3"><Col className={styles.htmlContainer} dangerouslySetInnerHTML={{
          __html: html
        }} /></Row>;
      $[13] = html;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    let t4;
    if ($[15] !== t2 || $[16] !== t3) {
      t4 = <Container className="pt-2">{t2}{t3}</Container>;
      $[15] = t2;
      $[16] = t3;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    return t4;
  }
}